import { useQuery } from "@tanstack/react-query";

import { getTheme } from "../../api/Theme";
import { ITheme } from "../../typings/Theme";

export const useTheme = (id: number) => {
  return useQuery<ITheme>({ queryKey: ["theme", id], queryFn: () => getTheme(id) });
};
